"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_MANAGER = exports.SET_IS_TEACHER = exports.SET_USER_INFO = exports.SET_TOKEN = void 0;
exports.SET_TOKEN = 'SET_TOKEN';
exports.SET_USER_INFO = 'SET_USER_INFO';
exports.SET_IS_TEACHER = 'SET_IS_TEACHER';
exports.SET_MANAGER = 'SET_MANAGER';
